var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140px",
    height: "70px",
    viewBox: "0 0 140 70",
    style: {
      enableBackground: "new 0 0 140 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 81.375 43.8301)",
    style: {
      fill: "#623D8F",
      fontFamily: "'OpenSans-Bold'",
      fontSize: 25
    }
  }, "AES"), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M65.062,45.984h-4.244c-0.353,0-0.638-0.285-0.638-0.638v-4.243c0-0.353,0.285-0.638,0.638-0.638 h4.244c0.353,0,0.638,0.285,0.638,0.638v4.243C65.699,45.699,65.414,45.984,65.062,45.984z M61.455,44.709h2.969v-2.968h-2.969 V44.709z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M54.733,22.037h-4.242c-0.353,0-0.638-0.285-0.638-0.638v-4.242c0-0.353,0.285-0.638,0.638-0.638 h4.242c0.353,0,0.638,0.285,0.638,0.638v4.242C55.371,21.752,55.086,22.037,54.733,22.037z M51.129,20.762h2.967v-2.967h-2.967 V20.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M49.692,27.536H36.233c-0.353,0-0.638-0.285-0.638-0.638s0.285-0.638,0.638-0.638h13.248 l2.493-1.854v-2.826c0-0.353,0.285-0.638,0.638-0.638s0.638,0.285,0.638,0.638v3.146c0,0.202-0.096,0.392-0.257,0.512l-2.92,2.171 C49.963,27.492,49.829,27.536,49.692,27.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M33.935,29.936c-1.618,0-2.935-1.317-2.935-2.938c0-1.619,1.316-2.936,2.935-2.936 c1.619,0,2.937,1.316,2.937,2.936C36.871,28.618,35.554,29.936,33.935,29.936z M33.935,25.338c-0.915,0-1.659,0.745-1.659,1.66 c0,0.916,0.744,1.662,1.659,1.662c0.916,0,1.661-0.746,1.661-1.662C35.596,26.083,34.851,25.338,33.935,25.338z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M38.968,46.162c-1.619,0-2.937-1.316-2.937-2.936s1.317-2.937,2.937-2.937s2.937,1.317,2.937,2.937 S40.587,46.162,38.968,46.162z M38.968,41.565c-0.916,0-1.661,0.745-1.661,1.661c0,0.915,0.745,1.66,1.661,1.66 s1.661-0.745,1.661-1.66C40.629,42.311,39.884,41.565,38.968,41.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M58.579,63.788c-1.619,0-2.937-1.317-2.937-2.937s1.317-2.937,2.937-2.937s2.937,1.317,2.937,2.937 S60.198,63.788,58.579,63.788z M58.579,59.19c-0.916,0-1.661,0.745-1.661,1.661s0.745,1.661,1.661,1.661s1.661-0.745,1.661-1.661 S59.495,59.19,58.579,59.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M60.493,43.864H41.501c-0.353,0-0.638-0.285-0.638-0.638s0.285-0.638,0.638-0.638h18.992 c0.353,0,0.638,0.285,0.638,0.638S60.846,43.864,60.493,43.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M51.173,37.808c-1.755,0-3.183-1.43-3.183-3.187c0-1.756,1.428-3.184,3.183-3.184 c1.756,0,3.185,1.428,3.185,3.184C54.357,36.378,52.929,37.808,51.173,37.808z M51.173,32.713c-1.052,0-1.907,0.856-1.907,1.908 c0,1.054,0.855,1.911,1.907,1.911c1.053,0,1.909-0.857,1.909-1.911C53.082,33.569,52.226,32.713,51.173,32.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M104.19,67.794c-18.083,0-32.794-14.71-32.794-32.792c0-18.084,14.711-32.796,32.794-32.796 c18.082,0,32.792,14.712,32.792,32.796C136.982,53.084,122.272,67.794,104.19,67.794z M104.19,3.481 c-17.379,0-31.519,14.141-31.519,31.521c0,17.378,14.14,31.517,31.519,31.517c17.378,0,31.517-14.139,31.517-31.517 C135.707,17.622,121.568,3.481,104.19,3.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M56.583,59.494c-0.163,0-0.326-0.062-0.451-0.187l-5.586-5.589c-0.119-0.12-0.187-0.282-0.187-0.451 V43.225c0-0.353,0.285-0.638,0.638-0.638s0.638,0.285,0.638,0.638v9.779l5.399,5.401c0.249,0.249,0.249,0.653,0,0.902 C56.909,59.432,56.746,59.494,56.583,59.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M72.034,35.259H53.72c-0.353,0-0.638-0.285-0.638-0.638s0.285-0.638,0.638-0.638h18.314 c0.353,0,0.638,0.285,0.638,0.638S72.387,35.259,72.034,35.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M47.778,35.259H19.521c-0.353,0-0.638-0.285-0.638-0.638s0.285-0.638,0.638-0.638h28.258 c0.353,0,0.638,0.285,0.638,0.638S48.131,35.259,47.778,35.259z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M10.078,51.937c-0.102,0-0.204-0.024-0.301-0.075l-5.149-2.761 c-0.149-0.081-0.261-0.218-0.31-0.381c-0.049-0.162-0.03-0.338,0.052-0.487L25.562,9.395c0.168-0.307,0.552-0.423,0.862-0.256 l5.146,2.771c0.149,0.08,0.261,0.217,0.309,0.38c0.049,0.163,0.03,0.338-0.052,0.487L10.639,51.604 C10.523,51.816,10.305,51.937,10.078,51.937z M5.797,48.279l4.025,2.158l20.577-37.708l-4.022-2.167L5.797,48.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M3.655,57.595c-0.104,0-0.21-0.025-0.306-0.078c-0.235-0.128-0.365-0.39-0.325-0.655l1.274-8.419 c0.031-0.205,0.16-0.382,0.346-0.475c0.186-0.092,0.403-0.089,0.587,0.008l5.149,2.761c0.184,0.1,0.308,0.282,0.332,0.489 c0.023,0.208-0.056,0.414-0.212,0.552l-6.424,5.658C3.958,57.541,3.807,57.595,3.655,57.595z M5.425,49.527L4.548,55.32 l4.421-3.894L5.425,49.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M29.283,12.043c-0.102,0-0.205-0.024-0.301-0.076l-1.186-0.637c-0.149-0.08-0.261-0.217-0.31-0.38 s-0.03-0.338,0.052-0.487l2.641-4.835c0.166-0.306,0.548-0.423,0.859-0.258l1.191,0.634c0.15,0.079,0.263,0.217,0.312,0.38 s0.03,0.34-0.052,0.489l-2.646,4.838C29.728,11.923,29.51,12.043,29.283,12.043z M28.966,10.511l0.062,0.033l2.033-3.717 l-0.064-0.034L28.966,10.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M11.174,29.533c-0.103,0-0.208-0.025-0.305-0.078c-0.31-0.169-0.423-0.556-0.254-0.865l9.574-17.53 c0.147-0.269,0.467-0.398,0.757-0.301l3.781,1.232c0.335,0.109,0.519,0.469,0.409,0.804c-0.109,0.336-0.468,0.521-0.804,0.409 l-3.278-1.068l-9.32,17.065C11.619,29.413,11.4,29.533,11.174,29.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M16.102,40.799c-0.102,0-0.205-0.024-0.302-0.076l-4.959-2.676 c-0.311-0.168-0.426-0.555-0.259-0.864s0.552-0.425,0.864-0.259l4.959,2.676c0.311,0.168,0.426,0.555,0.259,0.864 C16.549,40.678,16.329,40.799,16.102,40.799z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAes);
export default __webpack_public_path__ + "static/media/AES.045797c0dac9c0e78956f072ffd8aade.svg";
export { ForwardRef as ReactComponent };